import ReviewLike from "./ReviewLike";
import ReviewList from "./ReviewList";
import ReviewSearch from "./ReviewSearch";
import useAuth from "../../hooks/useAuth";
import { useSelector } from "react-redux";
const GeneralReview = function () {
  const { ceoInfo } = useAuth();
  const onSubmitSearch = () => {
  };
  const mCeo = useSelector((state) => state.Ceo);
  const ceoType = mCeo?.ceoType;
  return (
    <>
      <ReviewSearch onSubmitSearch={onSubmitSearch} />
      {/* {ceoType !== 'PREMIUM'&& <ReviewLike />} */}

      <ReviewList />
    </>
  );
};
export default GeneralReview;
